export default {
  name: 'wisk-angle-double-right',
  width: 35,
  height: 35,
  paths: [
    { d: 'M0,29.2c0-0.7,0.3-1.4,0.8-1.8l10-9.9l-10-9.9c-1-1-1-2.6,0-3.7s2.6-1,3.7,0l11.9,11.7c1,1,1,2.7,0,3.7L4.4,31.1 c-1,1-2.7,1-3.7,0C0.3,30.6,0,29.9,0,29.2z' },
    { d: 'M18,29.2c0-0.7,0.3-1.4,0.8-1.8l10-9.9l-10-9.9c-1-1-1-2.6,0-3.7c1-1,2.6-1,3.7,0l11.9,11.7c1,1,1,2.7,0,3.7L22.4,31.1 c-1,1-2.7,1-3.7,0C18.3,30.6,18,29.9,18,29.2z' }
  ]
}
